import { render, staticRenderFns } from "./CategoryLabel.vue?vue&type=template&id=36bccba5&scoped=true&"
import script from "./CategoryLabel.vue?vue&type=script&lang=ts&"
export * from "./CategoryLabel.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryLabel.vue?vue&type=style&index=0&id=36bccba5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bccba5",
  null
  
)

export default component.exports